import React from "react";

import FoodListItem from "./FoodListItem";
import { AutoSizer, List } from "react-virtualized";

const FoodList = ({ foods, updateFood, canEdit }) => {
  return (
    <div className="list-group container">
      {foods.map(food => (
        <FoodListItem
          key={food.name}
          food={food}
          update={updateFood}
          canEdit={canEdit}
        />
      ))}
    </div>
  );
  // return (
  //   <div
  //     className="list-group container"
  //     style={{ minHeight: "calc(100vh - 42px - 52px - 34px)" }}
  //   >
  //     <AutoSizer>
  //       {({ height, width }) => (
  //         <List
  //           width={width}
  //           height={height}
  //           rowCount={foods.length}
  //           rowHeight={64 * 1.5}
  //           rowRenderer={({ key, index, isScrolling, isVisible, style }) => (
  //             <FoodListItem
  //               key={key}
  //               food={foods[index]}
  //               update={updateFood}
  //               canEdit={canEdit}
  //               style={style}
  //             />
  //           )}
  //         />
  //       )}
  //     </AutoSizer>
  //   </div>
  // );
};

export default FoodList;



/** WEBPACK FOOTER **
 ** ./src/FoodList.js
 **/